export default "__VITE_PUBLIC_ASSET__b62674b9__"